module.exports = __webpack_public_path__ + "static/media/portfolio.7bc26bb5.gif";